import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import mitt from "mitt";
import request from '@/utils/request';
import 'animate.css';
import "swiper/css/swiper.css";
import setting from './utils/setting';
import store from './store';

Vue.use(ElementUI);
Vue.prototype.$bus = mitt();
Vue.prototype.$request = request;
Vue.prototype.$store = store;
Vue.prototype.$setting = setting;
Vue.config.productionTip = false;

Vue.directive('animate', {
  inserted: function (el, binding) {
    // 聚焦元素
    binding.addClass = () => {
      const { top } = el.getBoundingClientRect()
      const h = document.documentElement.clientHeight || document.body.clientHeight
      if (top < h) {
        if(el.className.indexOf(binding.value) == -1 ){
          // 下面单引号中间是一个空格
          el.className = binding.value+' '+el.className
        }
        if (binding.addClass) {
          window.removeEventListener('scroll', binding.addClass)
        }
      }
    }
    window.addEventListener('scroll', binding.addClass,true)
    binding.addClass()
  },
  unbind: function (el, binding) {
    if (binding.addClass) {
      window.removeEventListener('scroll', binding.addClass)
    }
  }
})
// router.beforeEach((to, from, next) => {    
//   // chrome
//   document.body.scrollTop = 0
//   // firefox
//   document.documentElement.scrollTop = 0
//   // safari
//   window.pageYOffset = 0
//   next()
// })
new Vue({
  render: (h) => h(App),
  router,
  store,
}).$mount("#app");
